// @ts-nocheck 0592174f
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: [],
      sections: [addPanel.sections.getSections().button.iconButtonsSection],
    };
  },
};
